var moduleMap = {
	"./webcomponents": () => {
		return Promise.all(/*! __federation_expose_webcomponents */[__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_lucide-react_dist_cjs_lucide-react_js"), __webpack_require__.e("vendors-node_modules_react-dom_client_js-node_modules_react-grid-layout_index_js-node_modules-7f87bb"), __webpack_require__.e("webpack_sharing_consume_default_styled-components_styled-components"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_features_serviceObject_components_ServiceObjectView_tsx"), __webpack_require__.e("src_platform_bridge_createFeatureComponent_tsx-src_platform_bridge_reactToWeb_tsx-src_platfor-324f25"), __webpack_require__.e("__federation_expose_webcomponents")]).then(() => (() => ((__webpack_require__(/*! ./src/index.tsx */ "./src/index.tsx")))));
	},
	"./platform": () => {
		return Promise.all(/*! __federation_expose_platform */[__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_lucide-react_dist_cjs_lucide-react_js"), __webpack_require__.e("webpack_sharing_consume_default_styled-components_styled-components"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_features_serviceObject_components_ServiceObjectView_tsx"), __webpack_require__.e("src_platform_bridge_createFeatureComponent_tsx-src_platform_bridge_reactToWeb_tsx-src_platfor-324f25"), __webpack_require__.e("__federation_expose_platform")]).then(() => (() => ((__webpack_require__(/*! ./src/platform/index.ts */ "./src/platform/index.ts")))));
	},
	"./shared": () => {
		return Promise.all(/*! __federation_expose_shared */[__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_lucide-react_dist_cjs_lucide-react_js"), __webpack_require__.e("webpack_sharing_consume_default_styled-components_styled-components"), __webpack_require__.e("src_features_serviceObject_components_ServiceObjectView_tsx"), __webpack_require__.e("__federation_expose_shared")]).then(() => (() => ((__webpack_require__(/*! ./src/shared/index.ts */ "./src/shared/index.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});